export default __webpack_public_path__ + "playstore-b.png";